<div class="mb-3 p-1">
  <bdg-label type="title"
    >{{ outerTitle }}
    <mat-icon *ngIf="control?.invalid && (control.dirty || control.touched)" color="warn" style="vertical-align: middle"
      >error</mat-icon
    >
  </bdg-label>
  <mat-label error="true"></mat-label>
  <div *ngIf="control?.invalid && (control.dirty || control.touched)">
    <div class="ml-1">
      <mat-hint>{{ hint }}</mat-hint>
      <mat-error class="mat-caption" *ngIf="errorMessage">{{ errorMessage }}</mat-error>
    </div>
  </div>
</div>

<div *ngIf="showPreview">
  <div class="row p-1">
    <div *ngFor="let parent of parents" class="col-md-3 mb-2">
      <bdg-info-label [label]="provider.description(parent)">
        {{ getSelectedMessage(parent) }}
      </bdg-info-label>
    </div>
  </div>
</div>

<div class="p-1 mt-2">
  <bdg-button [label]="buttonLabel" type="button" (click)="openModal(treeSearchField)"></bdg-button>
</div>

<ng-template #treeSearchField>
  <div class="mb-3 mt-3 tree-dialog-titlebar">
    <bdg-label type="title">{{ innerTitle }}</bdg-label>
  </div>

  <app-tree-search-component
    [placeholder]="placeholder"
    [provider]="provider"
    [control]="control"
    [label]="fieldLabel"
    [allExpanded]="allExpanded"
    [viewOnly]="viewOnly"
    [height]="height"
    (formConfirm)="closeModal($event)"
    (formCancel)="closeModal($event)"
  ></app-tree-search-component>
</ng-template>
